import { api } from '@shared/api/api';

export const disableTwoFactorAuthentication = api.createDelete('users/:id/two-factor-authentication');
